//@flow

import safeGetEntriesByType from 'app/packages/trace-logger/utils/safeGetEntriesByType';
import traceLogger from 'app/packages/trace-logger/singleton';
import type Stopwatch from 'app/packages/trace-logger/Stopwatch';

export default function addPageAnnotations(currTimer: ?Stopwatch) {
  const {
    fetchStart,
    firstInputDelayStart,
    firstInputDelayEnd,
    connectStart,
    connectEnd,
    domainLookupStart,
    domainLookupEnd,
    domLoading,
    domInteractive,
    domComplete,
    domContentLoadedEventStart,
    domContentLoadedEventEnd,
    navigationStart,
    requestStart,
    responseStart,
    responseEnd,
  } = window.performance.timing;

  if (currTimer) {
    const timer = currTimer;
    timer.addAnnotation('navigationStart', navigationStart);
    timer.addAnnotation('fetchStart', fetchStart);
    timer.addAnnotation('connectStart', connectStart);
    timer.addAnnotation('connectEnd', connectEnd);
    timer.addAnnotation('domainLookupStart', domainLookupStart);
    timer.addAnnotation('domainLookupEnd', domainLookupEnd);
    timer.addAnnotation('requestStart', requestStart);
    timer.addAnnotation('responseStart', responseStart);
    timer.addAnnotation('responseEnd', responseEnd);
    timer.addAnnotation('domLoading', domLoading);
    timer.addAnnotation('domInteractive', domInteractive);
    timer.addAnnotation('domContentLoadedEventStart', domContentLoadedEventStart);
    timer.addAnnotation('domContentLoadedEventEnd', domContentLoadedEventEnd);
    // Only add FID annotations if FIDStart is before navigationStart
    // (if it's not, then FIDStart was set relative to when the
    // browsing context was created instead of relative to navigationStart)
    // https://w3c.github.io/hr-time/#dfn-time-origin
    if (firstInputDelayStart && firstInputDelayEnd) {
      timer.addAnnotation('firstInputDelayStart', firstInputDelayStart);
      timer.addAnnotation('firstInputDelayEnd', firstInputDelayEnd);
    }
    timer.addAnnotation('domComplete', domComplete);
    // Track paints
    safeGetEntriesByType('paint').forEach((paint) => {
      const startTime = navigationStart + paint.startTime;
      timer.addAnnotation(paint.name, startTime);
    });
    // server annotations
    if (traceLogger.serverTraceData.annotations) {
      traceLogger.serverTraceData.annotations.forEach((entry) => {
        timer.addAnnotation(entry.key, entry.timestamp);
      });
    }
  }
}
